var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresencial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_10726",
    "data-name": "Grupo 10726",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.862,
    height: 12.008,
    viewBox: "0 0 10.862 12.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M10.957,9.607H.095S.234,4.345,5.526,4.251c0,0,5.431,0,5.431,5.356",
    transform: "translate(-0.095 2.401)",
    fill: "#64c5dd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M1.686,2.916A2.863,2.863,0,0,1,4.576.084a2.864,2.864,0,0,1,2.9,2.832,2.863,2.863,0,0,1-2.9,2.826,2.861,2.861,0,0,1-2.89-2.826",
    transform: "translate(0.854 -0.084)",
    fill: "#64c5dd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresencial);
export default __webpack_public_path__ + "static/media/presencial.cc9b5b0bcaa1d7c946dee7fe6ca3dfc2.svg";
export { ForwardRef as ReactComponent };